import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import {
  IConfigurationStaffClinicBasedOnCityListResponse,
  IConfigurationStaffClinicBasedOnCityListResponseData,
} from "@/api_framework/api_modals/Configuration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationStaffClinicBasedOnCityAPI = () => {
  const [clinicsByCities, setClinicsByCities] = useState<IConfigurationStaffClinicBasedOnCityListResponseData[]>([]);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (cityIds: string[]) => {
      try {
        if (cityIds?.length == 0) {
          setClinicsByCities([]);
          return { clinicsByCities, execute };
        }
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .post(
            `${CONFIGURATION_APIS?.STAFF_CLINICS_BASED_ON_CITY_LIST?.baseURL}`,
            { city_ids: cityIds },
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IConfigurationStaffClinicBasedOnCityListResponse>) => {
            if (res.data.status === true) {
              setClinicsByCities(res.data.data);
            } else {
              setClinicsByCities([]);
            }
          })
          .catch((e: AxiosError) => {
            captureError(e)
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        // Handle errors
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching staff details.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { clinicsByCities, execute };
};
